// extracted by mini-css-extract-plugin
export default {"tablet":"(min-width: 768px)","white":"#ffffff","wrapper":"P","link":"Q"};